import React, { useState } from "react";
import { Table, Select, Input, Tooltip } from "antd";
import styles from "./SupReciepe.module.css";
import { useNavigate } from "react-router-dom";
import { Dropdown, Modal, SubmitButton, TextComponent, SearchInput } from "../../../../components";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import { ReactComponent as StarIcon } from "../../../../assets/images/startIcon.svg";
import { ReactComponent as ActionIcon } from "../../../../assets/images/actionicon.svg";
import { SearchOutlined } from "@ant-design/icons";



const SupReciepe = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [filterModal, setFilterModal] = useState(false);
  const [category, setCategory] = useState({
    value: "Category",
    role: "Category",
    id: 1,
  });


  const columns = [
    // {
    //   title: "No",
    //   dataIndex: "No",
    //   key: "No",
    //   render: (text, record) => (
    //     <TextComponent className={styles.materialText} text={`${text}.`} />
    //   ),
    // },
    {
      title: "Product Name",
      dataIndex: "ProductName",
      key: "ProductName",
      render: (text, record) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
          {(record.ProductName === "French Batard Sliced" ||
            record.ProductName === "Multigrain bread" ||
            record.ProductName === "Pizza bread") && (
              <div className={styles.ingredientCellIconsDiv}>
                <Tooltip title="Allergy">
                  <ActionIcon className={styles.icons} />
                </Tooltip>
                <StarIcon className={styles.icons} />
              </div>

            )}
        </div>
      ),
    },
    {
      title: "Product Tag",
      dataIndex: "ProductTag",
      key: "Product Tag",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },
    {
      title: "Category",
      key: "Category",
      dataIndex: "Category",
    },
    {
      title: "",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => (
        <div>
          <SubmitButton
            title={"View"}
            btnClass={styles.tableBtn}
            primary
            onClick={() => navigate("/Training/ViewReciepe")}
          />
        </div>
      ),
    },
  ];

  const data = [
    {
      No: "1",
      ProductName: "French Batard Sliced",
      ProductTag: "French Bread",
      Category: "Bread",
      action: "View",
    },
    {
      No: "2",
      ProductName: "Baguette",
      ProductTag: "Cookies",
      Category: "General pastry",
      action: "Edit",
    },
    {
      No: "  3   ",
      ProductName: "Multigrain bread",
      ProductTag: "Bread",
      Category: "Bread",
      action: "View",
    },
    {
      No: "4",
      ProductName: "Pita bread",
      ProductTag: "Bread",
      action: "View",
      Category: "General pastry",

    },
    {
      No: "5",
      ProductName: "Sourdough",
      ProductTag: "Bread",
      Category: "Vienoiserrie ",
    },
    {
      No: "6",
      ProductName: "Pizza bread ",
      ProductTag: "Cookies",
      Category: "Vienoiserrie ",
      action: "View",
    },
  ];

  const categoryOpt = [
    {
      value: "Category",
      role: "Category",
      id: 1,
    },
    {
      value: "Bread",
      role: "Bread",
      id: 2,
    },
    {
      value: "General pastry",
      role: "General pastry",
      id: 3,
    },
    {
      value: "Vienoiserrie",
      role: "Vienoiserrie",
      id: 4,
    }, {
      value: "Assembly only",
      role: "Assembly only",
      id: 5,
    },
  ]


  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Recipe"}
        onSearch={(e) => setSearchTerm(e.target.value)}
        onSubmit={() => navigate("/RecipeManagement/CreateRecipe")}
        // showBackIcon={true}
        showFilterIcon={true}
        showSubmitButton={false}
        showSearch={true}
        rightControlsStyle={styles.rightControlsStyle}
        onClickFilter={() => setFilterModal(true)}


      />

      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={data}
          pagination={false}
          rowKey="staffId"
        />
      </div>



      {/* //////////////////// Filters ////////////////////// */}

      <Modal
        open={filterModal}
        onCancel={() => {
          setFilterModal(false);
        }}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}
        // btnStyle={{ width: "200px", }}
        twoButton
        okBtnTitle={"Apply Filters(1)"}
        cancelBtnTitle={"Reset All"}
        onClickCancelButton={() => setFilterModal(false)}
        onClickOkButton={() => {
          setFilterModal(false)
        }}
      // onBtnPress={() => setLimitExceedsModal(false)}
      >
        <SearchInput
          rightIcon={<SearchOutlined />}
          placeholder={"Search Product Tag"}

        />
        <Dropdown
          // label={"Category"}
          // labelClass={styles.DropDownLabel}
          value={category}
          inputStyle={{
            backgroundColor: "#F7F8F9",
            border: "1.5px solid #E8ECF4",
          }}
          inputClass={styles.DropdownInput}
          style={{ color: "var(--black-color)" }}
          options={categoryOpt}
          onChange={(e) => setCategory(e)}
        />
      </Modal>
    </div>
  );
};

export default SupReciepe;
